import Vue from 'vue'
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate'
import VueAuth from '@websanova/vue-auth';
import VueSocialSharing from 'vue-social-sharing'
import Cms from './modules/vue-cms/plugin';
import App from './App.vue'
import router from './router';
import i18n from './i18n';
import store from './store'; // Importa el store
//import { init } from '@sentry/browser';

import * as Sentry from '@sentry/vue';

import Echo from 'laravel-echo'         // GLOBAL IMPORT - DO NOT REMOVE
import Pusher from 'pusher-js'          // GLOBAL IMPORT - DO NOT REMOVE

// register the plugin on vue
import VueToast from 'vue-toast-notification';
import './styles/theme-vue-toast.css';

import Cache from './modules/Cache';

const AuthTokenExpirancyKey = 'default_auth_token_expirancy';
const AuthTokenKey = 'default_auth_token';

Vue.use(VueToast);
Vue.use(VueSocialSharing);
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Vuelidate);

Vue.router = router;

// Directives
Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
        // here I check that click was outside the el and his children
        if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
        }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

/* VideoJS */
import './modules/video';
import { Handler as WebstarsAuthHandler } from './modules/WebstarAuth/Handler';
/* VideoJS */

import VueCountdown from '@chenfengyuan/vue-countdown';

Vue.component(VueCountdown.name, VueCountdown);

Vue.use(VueAuth, {
    http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
    auth:  {
        request: function (req, token) {
            this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token});

            if (req.url.includes("auth/logout")) {
                WebstarsAuthHandler.logout();
            }
        },
        response: function (res) {
            const access_token = res.body.access_token;
            const webstars_login = res.body.webstars_login;

            if (access_token) {
                // Cache.deleteUserProfilePic();
                Cache.setUserData(res.body.user);
                localStorage.setItem(AuthTokenExpirancyKey, res.body.expires_in * 0.9 + Date.now());

                if (webstars_login) {
                    WebstarsAuthHandler.login(webstars_login);
                }

                return access_token;
            }
        }
    },
    
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    registerData: {method: 'POST'},
    refreshData: {method: 'POST', interval: process.env.JWT_TTL || 60},
    logoutData: {redirect: '/', makeRequest: true},
    authRedirect: {name: 'login'},
    notFoundRedirect: {name: 'dashboard'}
});

/* Interceptor para refresh innecesario */
Vue.http.interceptors.push(function(request, next) {
    const lastRefreshExpirancy = localStorage.getItem(AuthTokenExpirancyKey);
    if (request.url.includes("auth/refresh") && lastRefreshExpirancy && lastRefreshExpirancy > Date.now()) {
        return request.respondWith({}, {
            status: 200,
            url: request.url
      });
    };
});
/* Interceptor para refresh innecesario */

const API = process.env.VUE_APP_ROOT_API.split(";")[0].replace(/\/+$/, "");
Vue.use(Cms, {
    urls: {
        strings: `${API}admin-editable/string`,
        files: `${API}admin-editable/file`,
    },
});

/* Interceptor para modo mantenimiento */
Vue.http.interceptors.push(function(request, next) {
    next(function (res) {
        if ( (res.status === 503 || res.status === 0) && Vue.router.history.current.name !== 'maintenance' ) {
            Vue.router.push('/maintenance')
        }
    });
});
/* Interceptor para modo mantenimiento */

/* Interceptor para unauthorized */
Vue.http.interceptors.push(function(request, next) {
    let wasLoggedIn = Vue.auth.check();
    next(function (res) {
        if(wasLoggedIn){
            if(res.status === 401){
                Vue.auth.logout({redirect: {name: 'signedout'}});
            }
        }

        if(res.url.includes('auth/refresh')){
            if (res.status === 401 || res.status === 0 || res.status === 500) {
                //Vue.auth.logout();
                //fixme: desloguear al usuario con vue-auth
                localStorage.removeItem(AuthTokenKey);
                localStorage.removeItem(AuthTokenExpirancyKey);
                location.reload();
            }
        }
    });
});
/* Interceptor para unauthorized */

Vue.http.options.root = process.env.VUE_APP_ROOT_API_WRITE.split(";")[0].replace(/\/+$/, "");
Vue.config.productionTip = false;

if(process.env.VUE_APP_SENTRY_DSN){
    Sentry.init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || 'development',
        integrations: [
            Sentry.browserTracingIntegration({router}), 
            Sentry.replayIntegration({
                // Additional SDK configuration goes in here, for example:
                maskAllText: true,
                blockAllMedia: true,
              }),
        ],
      
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE || 1.0,
      
        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost'],
      
        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: process.env.VUE_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || 0.1,
        replaysOnErrorSampleRate: process.env.VUE_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || 1.0,
      });
}

/* Interceptor para anticache */
Vue.http.interceptors.push(function(request, next) {
    request.params['lang'] = i18n.locale;

    if(Vue.auth.check()){
        request.params['cdn_session_id'] = Vue.auth.token(); //TODO: MD5
    }
});
/* Interceptor para anticache */

/* Interceptor para site_type */
Vue.http.interceptors.push(function(request, next) {
    const siteType = store.state.general.site_type;

    if (siteType) {
        request.params['site_type'] = siteType;
    }
});
/* Interceptor para site_type */

/* Interceptor para socket id for laravel echo */
Vue.http.interceptors.push((request, next) => {
    if (window.Echo != undefined && window.Echo.socketId() != undefined) {
        request.headers.set('X-Socket-ID', window.Echo.socketId());
    }
    next();
});

/* Interceptor para socket id for laravel echo */

let app = new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');

export default app;